<app-spinner-page></app-spinner-page>
<router-outlet></router-outlet>
<a href="javascript:void(0);" id="scroll" title="Scroll to Top" *ngIf="isShow" (click)="gotoTop()">Top<span></span></a>
<a href="{{ 'urlWhatsApp' | translate }}" target="_blank" id="buttonWhatsApp" title="WhatsApp"><img src="assets/images/social_networks/icon_whatsapp.webp" id="iconButtonWhatsApp"></a>
